<template>
  <div class="search-form">
    <b-row align-h="between">
      <b-col cols="9">
        <b-form @reset="reset" onsubmit="return false">
          <b-input-group size="sm">
            <b-form-input
              @keyup.enter="query"
              type="search"
              v-model.trim="form.keyword"
              :placeholder="
                $l('INDEX.material_choose_search') ||
                  '物料编号/物料名称(中/英文)搜索... '
              "
            />
            <b-input-group-append>
              <b-button-group>
                <b-button-group slot="reference">
                  <b-button
                    variant="link"
                    size="sm"
                    class="search-dropdown-button"
                    squared
                    @click="openAdvqueryDialog"
                    >{{ $l('INDEX.advanced_search') || '高级搜索' }}</b-button
                  >
                  <b-button variant="primary" size="sm" @click="query">
                    <i class="fa fa-search" />
                  </b-button>
                </b-button-group>
              </b-button-group>
            </b-input-group-append>
          </b-input-group>
        </b-form>
      </b-col>
    </b-row>
    <el-dialog
      :title="$l('INDEX.advanced_search') || '高级搜索'"
      :show-close="true"
      :visible.sync="advqueryDialogVisible"
      width="1000px"
      :close-on-click-modal="false"
      append-to-body
    >
      <el-form ref="form" :model="form" label-width="120px">
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.material_choose_search_chinese_name') ||
                  '物料中文名称'
              "
            >
              <el-input
                v-model="form.materialName"
                clearable
                size="small"
                style="width: 100%"
              ></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.material_choose_search_chinese_name_en') ||
                  '物料英文名称'
              "
            >
              <el-input
                v-model.trim="form.materialNameEn"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-form-item
              :label="$l('INDEX.material_choose_search_supplier') || '厂商'"
            >
              <dict-select
                size="small"
                clearable
                filterable
                v-model="form.scmCode"
                :body="scmParams"
                url="/master/common/dict/scmCooperated"
              ></dict-select>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item
              :label="
                $l('INDEX.material_choose_search_supplier_item_no') ||
                  '工厂样品编号'
              "
            >
              <el-input
                v-model.trim="form.factoryItemNo"
                clearable
                size="small"
              ></el-input>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.material_choose_search_moq') || '起订量'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    v-model="form.moqStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    v-model="form.moqEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      size="small"
                      clearable
                      filterable
                      v-model="form.moqUnit"
                      :body="moqUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
          <el-col :span="12">
            <el-row :gutter="10">
              <el-form-item
                :label="$l('INDEX.material_choose_search_price') || '单价'"
              >
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    style="width: 100%"
                    size="small"
                    :min="0"
                    :step="1"
                    v-model="form.priceStart"
                  ></el-input-number>
                </el-col>
                <el-col class="line" :span="1">-</el-col>
                <el-col :span="8">
                  <el-input-number
                    controls-position="right"
                    size="small"
                    style="width: 100%"
                    :min="0"
                    :step="1"
                    v-model="form.priceEnd"
                  ></el-input-number>
                </el-col>
                <el-col :span="7">
                  <el-form-item>
                    <dict-select
                      size="small"
                      clearable
                      filterable
                      v-model="form.currencyUnit"
                      :body="currencyUnitParams"
                      url="/master/common/dict/biz"
                    ></dict-select>
                  </el-form-item>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
        <el-row :gutter="20">
          <el-col :span="12">
            <el-row>
              <el-form-item
                :label="$l('INDEX.table_label_modification_date') || '修改时间'"
              >
                <el-col :span="24">
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeStart"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                  <el-col class="line" :span="2">-</el-col>
                  <el-col :span="11">
                    <el-date-picker
                      v-model="form.modifyTimeEnd"
                      type="date"
                      size="small"
                      value-format="yyyy-MM-dd"
                      :placeholder="$l('INDEX.tips_select_date') || '选择日期'"
                      style="width: 100%"
                    ></el-date-picker>
                  </el-col>
                </el-col>
              </el-form-item>
            </el-row>
          </el-col>
        </el-row>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button size="small" @click="closeAdvqueryDialog">
          {{ $l('INDEX.btn_cancel_query') || '取消查询' }}
        </el-button>
        <el-button size="small" type="warning" @click="reset">
          {{ $l('INDEX.btn_reset_filter') || '重置条件' }}
        </el-button>
        <el-button size="small" type="primary" @click="advquery">
          {{ $l('INDEX.btn_data_retrieval') || '数据检索' }}
        </el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
// 初始表单
const initForm = { keyword: '', materialStatusList: ['Y'] }
export default {
  props: {
    detailMaterialCategoryCode: String,
    mainMaterialCategoryCode: String,
  },
  data() {
    return {
      advqueryDialogVisible: false,
      form: { ...initForm },
      scmParams: {},
      moqUnitParams: { dictType: 'moqUnit' },
      currencyUnitParams: { dictType: 'currencyUnit' },
      productLineParams: { dictType: 'productLine' },
    }
  },
  computed: {
    params() {
      return {
        detailMaterialCategoryCode: this.detailMaterialCategoryCode,
        mainMaterialCategoryCode: this.mainMaterialCategoryCode,
      }
    },
  },
  watch: {
    params: {
      handler() {
        this.query()
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    // 初始查询
    query({ isReset = true } = {}) {
      if (isReset) {
        this.$emit('reset')
      }
      const params = {
        ...this.form,
        mainMaterialCategoryCode: this.mainMaterialCategoryCode,
        detailMaterialCategoryCode: this.detailMaterialCategoryCode,
      }
      this.$emit('query', params)
    },
    // 高级查询
    advquery() {
      this.form.keyword = ''
      this.query()
      this.closeAdvqueryDialog()
    },
    // 重置查询条件 - 高级查询
    reset() {
      this.form = { ...initForm }
    },
    // 打开高级查询
    openAdvqueryDialog() {
      this.advqueryDialogVisible = true
    },
    // 关闭高级查询
    closeAdvqueryDialog() {
      this.advqueryDialogVisible = false
    },
  },
}
</script>
<style lang="scss" scoped>
.el-form-item {
  margin-bottom: 0px;
}
.line {
  text-align: center;
}
</style>
